import { render, staticRenderFns } from "./HSCodesPopup.vue?vue&type=template&id=843707d0&scoped=true"
import script from "./HSCodesPopup.vue?vue&type=script&lang=js"
export * from "./HSCodesPopup.vue?vue&type=script&lang=js"
import style0 from "./HSCodesPopup.vue?vue&type=style&index=0&id=843707d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843707d0",
  null
  
)

export default component.exports